import React from 'react';

const LeagueContext = React.createContext();

export default LeagueContext;
